/* dv-parca-koleksiyon.js — [DV-PARCA-KOLEKSIYON 2026-08-02]
   Koleksiyon/arama kartlarindaki "Tükendi" rozeti Shopify varyant stogundan gelir.
   Urun RULO yedegiyle satilabiliyorsa (parca VEYA oval/daire-V2 haritasinda + en az bir olcunun
   rulosu canli stokta) rozet kaldirilir, kart normal gorunur.
   Sonuclar sessionStorage'da 10 dk onbelleklenir — sayfalar arasi API tekrarlanmaz. */
(function () {
  'use strict';
  var TAG = '[DVParcaKol]';
  var TTL = 10 * 60 * 1000;
  var isleniyor = {};

  function cacheGet(h) {
    try {
      var raw = sessionStorage.getItem('dvPrKol:' + h);
      if (!raw) return null;
      var o = JSON.parse(raw);
      if (Date.now() - o.t > TTL) return null;
      return o;
    } catch (e) { return null; }
  }
  function cacheSet(h, varMi) {
    try { sessionStorage.setItem('dvPrKol:' + h, JSON.stringify({ t: Date.now(), v: !!varMi })); } catch (e) {}
  }

  function handleBul(card) {
    var a = card.querySelector('a[href*="/products/"]');
    if (!a) return null;
    var m = (a.getAttribute('href') || '').match(/\/products\/([^?#]+)/);
    if (!m) return null;
    try { return decodeURIComponent(m[1]); } catch (e) { return m[1]; }
  }

  function rozetKaldir(card) {
    card.querySelectorAll('.hdt-badge__sold_out').forEach(function (b) { b.style.display = 'none'; });
    card.classList.remove('hdt-pr-sold_out');
  }

  /* herhangi bir olcunun rulosu var mi? — sirayla dener, ilk VAR'da durur */
  function ruloVarMi(API, recs, cb) {
    var i = 0;
    (function sonraki() {
      if (i >= recs.length) { cb(false); return; }
      var r = recs[i++];
      fetch(API + '/check-roll-availability?barcode=' + encodeURIComponent(r.bar) + '&length=' + (r.boy / 100))
        .then(function (x) { return x.json(); })
        .then(function (d) { if (d && d.available) cb(true); else sonraki(); })
        .catch(function () { sonraki(); });
    })();
  }

  /* [DV-KOL-V2 2026-08-03] Iki AYRI veri kaynagi var ve YAPILARI FARKLI:
       parca (__DV_PARCA_RULO__): urunler[h].olculer = NESNE, anahtar = varyant id
       V2    (__DV_SABIT_RULO_V2__): urunler[h].olculer = DIZI (oval/daire, olculer toplardan uretilir)
     Ayni donguye sokulursa yanlis barkod/boy sorgulanir — bu yuzden ayri normalize edilir.
     Doner: {api, recs:[{bar, boy}]} veya null. */
  function kaynakBul(h) {
    var P = window.__DV_PARCA_RULO__;
    if (P && P.urunler && P.urunler[h]) {
      var o = P.urunler[h].olculer || {};
      return { api: P.api, recs: Object.keys(o).map(function (k) { return o[k]; }) };
    }
    var V = window.__DV_SABIT_RULO_V2__;
    if (V && V.urunler && V.urunler[h]) {
      var a = V.urunler[h].olculer || [];
      return { api: V.api, recs: a.slice() };
    }
    return null;
  }

  function tara() {
    if (!window.__DV_PARCA_RULO__ && !window.__DV_SABIT_RULO_V2__) return;
    document.querySelectorAll('hdt-card-product.hdt-pr-sold_out, .hdt-card-product.hdt-pr-sold_out').forEach(function (card) {
      var h = handleBul(card);
      if (!h) return;
      var K = kaynakBul(h);
      if (!K || !K.recs.length) return;
      var c = cacheGet(h);
      if (c) { if (c.v) rozetKaldir(card); return; }
      if (isleniyor[h]) return;
      isleniyor[h] = true;
      ruloVarMi(K.api, K.recs, function (varMi) {
        cacheSet(h, varMi);
        isleniyor[h] = false;
        if (varMi) {
          document.querySelectorAll('hdt-card-product.hdt-pr-sold_out, .hdt-card-product.hdt-pr-sold_out').forEach(function (k2) {
            if (handleBul(k2) === h) rozetKaldir(k2);
          });
          console.log(TAG, 'rozet kaldirildi (rulo var):', h);
        }
      });
    });
  }

  function init() {
    tara();
    setInterval(tara, 1500); // sayfalama / lazy-load kartlari da yakala; onbellek API'yi korur
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
